<app-input-form
  [formControl]="itemsControl"
  [testId]="testId"
  [inputLabel]="inputLabel"
  [maxLength]="maxLength"
  [numeric]="numeric"
  showLabel="true"
  inputClass="w-100"
  class="w-100"
  (keyup.enter)="onEnterKeyup($event.target.value)"
  (blurChange)="onBlur($event.target.value)"
></app-input-form>

<mat-chip-listbox class="d-block" *ngIf="shouldShowChips">
  <mat-chip-option *ngFor="let item of items" [removable]="true" (removed)="onRemoveItem(item)" class="chip">
    {{ item }}
    <mat-icon matChipRemove>cancel</mat-icon>
  </mat-chip-option>
</mat-chip-listbox>
